export class LotRequest {
    public company_code;
    public supplier_code;
    public language;
    public lot_number;
}



// WEBPACK FOOTER //
// ./src/app/model/lot/lot_request.model.ts